import React from "react";
import { useTranslation } from "react-i18next";

import { BetOffer } from "@models";

import LinkActiveEventsHOC from "./LinkActiveEventsHOC";
import BetOfferItemTime from "@features/my-bets/desktop/common/BetOfferItemTime";

export default function EventData(props: { offer: BetOffer }) {
	const { t } = useTranslation("mybets");

	const shouldRenderLiveScore =
		props.offer.isLive &&
		props.offer.formattedResultAtBetTime !== "" &&
		!props.offer.isMulti;

	return (
		<td className="table--bets__td table--bets__td--event">
			<LinkActiveEventsHOC
				eventId={props.offer.eventId}
				className="u-anchor"
				isLive={props.offer.isLive}
			>
				{props.offer.isMulti ? (
					<>
						<div className="table--bets__event">
							{props.offer.multiOffers &&
								props.offer.multiOffers.length > 0 && (
									<i className="table--bets__event__icon u-icon u-icon--sml u-icon--bb--active" />
								)}
							{props.offer.multiEventName}
						</div>
						<BetOfferItemTime offer={props.offer} />
					</>
				) : (
					<>
						<div className="table--bets__event">
							{props.offer.multiOffers &&
								props.offer.multiOffers.length > 0 && (
									<i className="table--bets__event__icon u-icon u-icon--sml u-icon--bb--active" />
								)}
							{`${props.offer.teamOneString} - ${props.offer.teamTwoString}`}
						</div>
						<BetOfferItemTime offer={props.offer} />
					</>
				)}

				{shouldRenderLiveScore ? (
					props.offer.sportData.sportAbrv === "cricket" ? (
						props.offer.sportData.result.scorePerPeriod.length >
						1 ? (
							(() => {
								const spp =
									props.offer.sportData.result.scorePerPeriod;
								return (
									<div className="table--bets__live-score">
										*{t("ITEM.LIVE_SCORE").toUpperCase()}*{" "}
										{`${spp[0].home || 0}/${spp[1].home || 0} : ${spp[0].away || 0}/${spp[1].away || 0}`}{" "}
										{
											props.offer
												.scorePerPeriodAtBetTimeString
										}
									</div>
								);
							})()
						) : (
							(() => {
								const spp =
									props.offer.sportData.result.scorePerPeriod;
								return (
									<div className="table--bets__live-score">
										*{t("ITEM.LIVE_SCORE").toUpperCase()}*{" "}
										{`${spp[0].home || 0} : ${spp[0].away || 0}`}{" "}
										{
											props.offer
												.scorePerPeriodAtBetTimeString
										}
									</div>
								);
							})()
						)
					) : (
						<div className="table--bets__live-score">
							*{t("ITEM.LIVE_SCORE").toUpperCase()}*{" "}
							{props.offer.formattedResultAtBetTime}{" "}
							{props.offer.scorePerPeriodAtBetTimeString}
						</div>
					)
				) : (
					<></>
				)}
			</LinkActiveEventsHOC>
		</td>
	);
}
